import {IStorageService} from "./storage.service.interface";
import {IStorageLock} from "./storage-lock.interface";

export interface ILocalStorageService extends IStorageService {
    acquireTabLock(options: IAcquireTabLockOptions): Promise<IStorageLock>;
}

export class TabLockKey {
    constructor(private readonly _originalKey: string) {
    }

    get name(): string {
        return `tabLock_${this._originalKey}`
    }

}

export interface IAcquireTabLockOptions {
    browserTabId: string;
    lockKey: TabLockKey;
}


